export default "__VITE_ASSET__COuQ0liQ__"